import { Component, OnInit } from '@angular/core';
import { MassQueriesService } from './../../../../components/mass-queries/services/mass-queries.service';
import { IUser } from './../../../../core/models/user/user';
import { LocalStorageService } from './../../../../core/services/local-storage/local-storage.service';
import { environment } from '../../../../../environments/environment';
import { RoutingPath } from './../../../../configs/routing-path';
import { Router } from '@angular/router';
import { InformationFormatting } from './../../../../core/helpers/information-formatting/information-formatting';

@Component({
  selector: 'app-aportes',
  templateUrl: './aportes.component.html',
  styleUrls: ['./aportes.component.scss']
})
export class AportesComponent implements OnInit {

  public userloggedin: IUser;
  showDonut = false;
  dChartAffiliationsData = [0, 0];
  dChartAffiliationsDataLabels = ['',''];
  totalAffiliates = 0;
  totalAffiliatesC = 0;
  affiliatesM = 0;
  affiliatesF = 0;
  affiliatesCatA = "";
  affiliatesCatB = "";
  affiliatesCatC = "";
  linkConMas = "";
  

  constructor(private massQueriesService:MassQueriesService,
              private _storage: LocalStorageService,
              private _router: Router) { }
  ngOnInit() {
    this.linkConMas = RoutingPath.appRouting.components.workers_information.path + "/" 
      + RoutingPath.appRouting.components.workers_information.pages.consultation_demografic.path
    this.userloggedin = this._storage.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);

    const numDoc = this.userloggedin.docNumberCompany+this.userloggedin.checkDigit;
    const typeDoc = InformationFormatting.returnNameDocumentCompany(this.userloggedin.docTypeCompany);
    this.massQueriesService.getNumAffiliations(typeDoc,numDoc).subscribe(
      res=>{
        this.dChartAffiliationsData[0] = Number(res.personasConSubsidio);
        this.dChartAffiliationsData[1] = Number(res.personasSinSubsidio);
        this.affiliatesM = Number(res.mujeres);
        this.affiliatesF = Number(res.hombre);
        this.totalAffiliates = Number(res.trabajadores);
        this.totalAffiliatesC = this.dChartAffiliationsData[0]+this.dChartAffiliationsData[1];
        this.affiliatesCatA = this.getPercentage(this.dChartAffiliationsData[0],this.totalAffiliatesC).toFixed(2);
        this.affiliatesCatB = this.getPercentage(this.dChartAffiliationsData[1],this.totalAffiliatesC).toFixed(2);
        this.showDonut = true;
      }
    );
    
  }

  getPercentage(valor: number,total: number){
    return (valor>0)?(valor*100)/total:0;
  }

  openLink(link:string){
    this._router.navigate([link]);
  }

}
